import React from "react";
import Icon from "components/AppIcon";

const CrimeStatsBar = ({ stats }) => {
  const items = [
    { label: "Total Crimes", value: stats?.totalCrimes, icon: "Skull", color: "var(--color-primary)" },
    { label: "Successful", value: stats?.successful, icon: "CheckCircle", color: "var(--color-success)" },
    { label: "Failed", value: stats?.failed, icon: "XCircle", color: "var(--color-error)" },
    { label: "Total Earned", value: `$${stats?.totalEarned?.toLocaleString()}`, icon: "DollarSign", color: "var(--color-accent)" },
    { label: "Times Jailed", value: stats?.timesJailed, icon: "Lock", color: "var(--color-warning)" },
    { label: "Success Rate", value: `${stats?.successRate}%`, icon: "Target", color: "#a855f7" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
      {items?.map((item) => (
        <div key={item?.label} className="rounded-xl p-3 text-center" style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}>
          <div className="flex items-center justify-center mb-1.5">
            <Icon name={item?.icon} size={16} color={item?.color} />
          </div>
          <div className="font-heading text-sm font-bold mb-0.5" style={{ color: item?.color }}>{item?.value}</div>
          <div className="font-caption text-xs text-muted-foreground">{item?.label}</div>
        </div>
      ))}
    </div>
  );
};

export default CrimeStatsBar;